import { render } from "./ReportNextEvents.vue?vue&type=template&id=e7c98890"
import script from "./ReportNextEvents.vue?vue&type=script&lang=js"
export * from "./ReportNextEvents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportNextEvents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7c98890"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7c98890', __exports__)) {
    console.log('reload')
    api.reload('e7c98890', __exports__)
  }
  
  module.hot.accept("./ReportNextEvents.vue?vue&type=template&id=e7c98890", () => {
    console.log('re-render')
    api.rerender('e7c98890', render)
  })

}


export default __exports__